
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import DerevaLogoWhite from './Img/Dereva_logo_white.svg';
import DerevaLogo8D9AC9 from './Img/Dereva_logo_8D9AC9.svg';

import {
    useNavigate,
} from 'react-router-dom';

export type TopBarProps = {
    paths: {
        [group: string]: {
            name: string;
            url: string;
            icon?: React.JSX.Element;
            hidden?: boolean;
        }[];
    };
    user?: any;
    onSignOut?: () => void;
    color?: string;
}
const TopBar = (props: TopBarProps): React.JSX.Element => {
    const history = useNavigate();
    // 今いるURLを取得する
    const currentPath = window.location.hash.replace(/^#/, '') || '/';
    // 今いるURLがどのgroupに属するかを取得する
    const currentGroup = Object.keys(props.paths).find((group) => {
        return props.paths[group].some((p) => currentPath.startsWith(p.url));
    });
    const [open, setOpen] = React.useState<boolean>(false);
    return (
        <Box
            sx={{
                height: '64px',
            }}
        >
            <AppBar
                sx={{ backgroundColor: props.color ? props.color : 'primary.main' }}
                position="static"
            >
                <Toolbar>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            onClick={() => history('/')}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                src={DerevaLogoWhite}
                                alt="Dereva Logo"
                                width="180px"
                            />
                            <Typography
                                variant="h6"
                            >
                                {currentGroup ? currentGroup : ''}
                            </Typography>
                        </Box>
                    </Box>
                    <IconButton
                        size="large"
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        onClick={() => setOpen(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer
                open={open}
                anchor="right"
                onClose={() => setOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: 'info.main',
                    }
                }}
            >
                <Box
                    textAlign={'center'}
                >
                    <img
                        src={DerevaLogo8D9AC9}
                        alt="Dereva Logo"
                        width="180px"
                    />
                </Box>
                <List>
                    {Object.keys(props.paths).map((group) => {
                        const paths = props.paths[group].filter((p) => !p.hidden);
                        return (
                            <>
                                {/* 見出し */}
                                <Typography
                                    color='secondary'
                                    variant='h6'
                                    fontWeight='bold'
                                    sx={{
                                        marginX: '16px',
                                        marginY: '8px',
                                    }}
                                >
                                    {group}
                                </Typography>
                                {paths.map((p) => (
                                    <ListItemButton
                                        key={p.name}
                                        onClick={() => {
                                            history(`${p.url}`)
                                        }}
                                    >
                                        <ListItemIcon
                                        >
                                            {p.icon ? (
                                                p.icon
                                            ): null}
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Typography
                                                color='secondary'
                                            >
                                                {p.name}
                                            </Typography>
                                        </ListItemText>
                                    </ListItemButton>
                                ))}
                            </>
                        )
                    })}
                </List>
            </Drawer>
        </Box>
    )
}

export default TopBar
